import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';
import contriesList from 'iso-3166-1-alpha-2';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchServices } from '../../../../../../../actions/services-api';
import ServiceInfo from '../../../../../../../constants/models/serviceInfo';
import { useDispatch, useSelector } from 'react-redux';
import { ConnectionTypes } from '../../../../../../../constants/utils/connectionTypes';
import { BankDetails } from '../bankDetails';
import { BranchBox } from './branchBox';
import * as Loadings from '../../../../../../../constants/loadings/service';

export const BranchBase = ({ branch, index, totalBranches, connectionType, title, isMain, setShowCustomBox, canCollapse, removeBranch, bottomRef, serviceDatas, isLoading, userId, displayComments, disableModifications, generateLetters }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const dispatch = useDispatch();
    const [branchIsSelected, setBranchIsSelected] = useState(null);
    const [selectedOption, setSelectedOption] = useState(undefined);
    const [selectedBranch, setSelectedBranch] = useState(undefined);
    const [searchFilter, setSearchFilter] = useState([]);
    const [selectSearch, setSelectSearch] = useState('');
    const [searchPage, setSearchPage] = useState(0);
    const [loadedServices, setLoadedServices] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [wasSaved, setWasSaved] = useState(false);
    const formRef = useRef(null);

    useEffect(() => {
        setSearchPage(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectSearch]);

    useEffect(() => {
        if (!R.isNil(selectedBranch) && !R.isNil(setBranchIsSelected)) {
            setBranchIsSelected(selectedBranch);
        }
        if (R.isNil(selectedBranch) && !R.isNil(setBranchIsSelected)) {
            setBranchIsSelected(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBranch]);

    useEffect(() => {
        if (!R.isNil(branch) && !R.isNil(loadedServices) && loadedServices.length > 0) {
            //find branch and option
            let srv = !R.isNil(branch.serviceId) ? loadedServices.find(sr => sr.name === branch.serviceName) : undefined;
            if (!R.isNil(srv)) {
                srv.branches.sort((a, b) => (a.name > b.name) ? 1 : -1);
                let option = srv.branches.find(b => b.id === branch.serviceId);
                setSelectedOption(srv);
                setSelectedBranch(option);
                setSearchFilter({ label: srv.name, value: srv.name });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedServices, branch]);

    function updateLoadedItems(data) {
        if (!R.isNil(data) && data.items.length > 0) {
            //remove branches that are already registered
            if (R.isNil(loadedServices) || loadedServices.length === 0) {
                setLoadedServices(data.items.map(e => new ServiceInfo(e)));
            }
            else {
                let tmpLoadedServices = loadedServices;
                data.items.forEach(d => {
                    if (loadedServices.findIndex(i => i.name === d.name) === -1) {
                        tmpLoadedServices.push(new ServiceInfo(d));
                    }
                    setLoadedServices(tmpLoadedServices);
                });
            }
        }
    }

    const sleep = ms =>
        new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, ms);
        });

    async function searchAreEqual(search) {
        //Wait one second, after user stops typing, before sending the request
        await sleep(1000);
        return search === selectSearch;
    }

    async function loadOptions(search, loadedOptions, { page }) {
        let response = [];
        let responseJSON = [];
        let hasMore = false;
        if (search === '' || R.isNil(search)) {
            response = await dispatch(fetchServices(connectionType, page));
            responseJSON = response.items.map(e => new ServiceInfo(e));
            hasMore = responseJSON.length === 100;
        }
        else if ((search !== '' && !R.isNil(search))) {
            let areEqual = await searchAreEqual(search);
            if (areEqual) {
                response = await dispatch(fetchServices(connectionType, selectSearch !== search ? 0 : searchPage, search));
                responseJSON = response.items.map(e => new ServiceInfo(e));
                if (responseJSON.length === 100) {
                    setSearchPage(searchPage + 1);
                    hasMore = true;
                }
                else {
                    hasMore = false;
                }
            }
            else {
                hasMore = true;
            }
        }
        updateLoadedItems(response);

        let filteredOptions = responseJSON.filter(s => s.branches.length > 0).length > 0 && responseJSON.filter(s => s.branches.length > 0).map(sr => {
            return {
                label: sr.name,
                value: sr.name
            };
        });

        return {
            options: filteredOptions,
            hasMore: hasMore,
            additional: {
                page: !R.isNil(search) && search !== '' ? searchPage : page + 1,
            }
        };
    }

    useEffect(() => {
        loadOptions("", null, 0);
        if (!R.isNil(branch)) {
            setCollapsed(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (index !== totalBranches - 1 && canCollapse === true && totalBranches > 0) {
            setCollapsed(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalBranches]);

    useEffect(() => {
        if (!R.isNil(branch) ? (isLoading.includes(Loadings.ADD_NEW_SERVICE + branch.id) || isLoading.includes(Loadings.UPDATING_SERVICE_DATA + branch.id)) :
            !R.isNil(selectedBranch) && (isLoading.includes(Loadings.ADD_NEW_SERVICE + selectedBranch.id) || isLoading.includes(Loadings.UPDATING_SERVICE_DATA + selectedBranch.id))) {
            setWasSaved(true);
        }
    }, [isLoading, selectedBranch]);

    if (wasSaved && collapsed === false &&
        !R.isNil(branch) && !isLoading.includes(Loadings.ADD_NEW_SERVICE + branch.id) && !isLoading.includes(Loadings.UPDATING_SERVICE_DATA + branch.id) &&
        JSON.stringify(branch) === JSON.stringify(serviceDatas.find(b => b.id === branch.id))) {
        setWasSaved(false);
        setCollapsed(true);
    }

    let currentServiceIds = serviceDatas.map(s => {
        return s.serviceId;
    });
    currentServiceIds = R.uniq(currentServiceIds);

    let auxTitle = !R.isNil(selectedBranch) ? selectedBranch.name : undefined;
    return (
        <section className={"card card-body" + (isMain ? '' : ' mt-4')} id={title + index} ref={bottomRef}>
            <div className="card-header p-0" id={"headingUserDetail" + title + index} role="button" onClick={() => {
                setTimeout(() => {
                    setCollapsed(collapsed === true ? false : true);
                }, 200);
            }}>
                <div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#accordion" + title + "Donnes" + index} aria-expanded={collapsed === false} aria-controls={"accordion" + title + "Donnes"}>
                    <h4 className="h3 font-weight-black container-tight my-auto">{isMain ? title + (title === "Sport" ? ' Principal' : ' Principale') : 'Autre ' + title}</h4>{!R.isNil(auxTitle) ? <span className="mr-auto align-middle"><i className="eva eva-arrow-right mx-2 align-middle o-30"></i><span className="o-60 align-middle">{auxTitle}</span></span> : ''}
                    <button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal"><i className={"eva " + (collapsed === false ? 'eva-arrow-ios-upward-outline' : 'eva-arrow-ios-downward-outline')}></i></button>
                </div>
            </div>
            <form ref={formRef} className={"collapse" + (collapsed === false ? ' show' : '')} id={"accordion" + title + "Donnes" + index} aria-labelledby={"headingUserDetail" + title + index} data-parent={"#" + title + index}>
                <div className="block mt-4" >
                    <div className="grid-sm grid-sm-1 grid-md-2 align-items-center mt-2 mb-sm">
                        <h5 className="h4 text-uppercase text-secondary font-weight-black my-auto">Votre {title} *</h5>
                        <div className="ml-md-auto">
                            <button type="button" disabled={!R.isNil(branchIsSelected)} className="btn p-0 align-middle text-gray no-outline text-md-right"
                                onClick={
                                    (e) => {
                                        e.preventDefault();
                                        setShowCustomBox(true);
                                        removeBranch(index);
                                    }
                                }
                            >Cliquez ici si vous ne trouvez pas votre <span className="text-uppercase">{title}</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i></button>
                        </div>
                    </div>
                    <div className="row gx-2 mt-n2">
                        <div className="col-12 col-md-5">
                            <div className="form-group">
                                <label className="h6 font-weight-bolder my-auto" htmlFor={title + index}>Nom de votre {title}</label>

                                <AsyncPaginate id={"search-" + title} className="form-control form-select bg-dim rounded-max border-none no-focus shadow-none"
                                    value={searchFilter}
                                    loadOptions={loadOptions}
                                    onChange={(option) => {
                                        setSearchFilter({ label: option.value, value: option.value });
                                        if (!R.isNil(loadedServices)) {
                                            let srv = loadedServices.find(sr => sr.name === option.value);
                                            srv.branches.sort((a, b) => (a.name > b.name) ? 1 : -1);
                                            let tmpBranches = srv.branches.filter(br => R.isNil(branch)/* || (branch.serviceId !== br.id && branch.id !== br.id) ? !currentServiceIds.includes(br.id) : true*/);
                                            if (!R.isNil(srv)) {
                                                setSelectedOption(srv);
                                                if (tmpBranches.length > 0) {

                                                    setSelectedBranch(tmpBranches[0]);
                                                }
                                                else {
                                                    setSelectedBranch(undefined);
                                                }
                                            }
                                        }
                                    }}
                                    isMulti={false}
                                    cacheUniqs={[]}
                                    additional={{ page: 0 }}
                                    onInputChange={(searchInput) => {
                                        setSelectSearch(searchInput);
                                        if (!searchInput.includes(selectSearch)) {
                                            setSearchPage(0);
                                        }
                                    }}
                                    placeholder="Rechercher..."
                                    loadingMessage={() => "Chargement..."}
                                    noOptionsMessage={() => "Aucun résultat"}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-7">

                            <div className="form-group">
                                <label className="h6 font-weight-bolder my-auto" htmlFor={"b" + title + index}>Branche</label>
                                <select className="custom-select" id={"b" + title + index} tabIndex={-98} onChange={(e) => {
                                    e.preventDefault();
                                    let tmpBranch = selectedOption.branches.find(b => b.id === e.target.value);
                                    if (!R.isNil(tmpBranch)) {
                                        setSelectedBranch(tmpBranch);
                                    }
                                }} value={selectedBranch?.id}>
                                    {
                                        !R.isNil(selectedOption) && !R.isNil(loadedServices) ? selectedOption.branches.map((s, index) => {
                                            // if (currentServiceIds.includes(s.id) && (R.isNil(branch) || branch.serviceId !== s.id)) {
                                            //     return '';
                                            // }
                                            return <option key={index} value={s.id}>{s.name}</option>;
                                        }) : ''
                                    }
                                </select>
                            </div>

                            <div className="form-block">
                                <div className="form-group">
                                    <label className="h6 font-weight-bolder my-auto" htmlFor={"Adresse" + index}>Adresse de l'agence</label>
                                    <input disabled required type="text" className="form-control" id={"Adresse" + index} value={!R.isNil(selectedBranch) ? selectedBranch.address["streetAddress"] : ''} />
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-12 col-sm-6 col-lg">
                                        <label className="h6 font-weight-bolder my-auto" htmlFor={"Postal" + index}>Code Postal</label>
                                        <input disabled type="text" className="form-control" id={"Postal" + index} value={!R.isNil(selectedBranch) ? selectedBranch.address["postalCode"] : ''} />
                                    </div>
                                    <div className="form-group col-12 col-sm-6 col-lg">
                                        <label className="h6 font-weight-bolder my-auto" htmlFor={"Ville" + index}>Ville</label>
                                        <input disabled type="text" className="form-control" id={"Ville" + index} value={!R.isNil(selectedBranch) ? selectedBranch.address["addressLocality"] : ''} />
                                    </div>
                                    <div className="form-group col-12 col-sm-6 col-lg">
                                        <label className="h6 font-weight-bolder my-auto" htmlFor={"Pays" + index}>Pays</label>
                                        <select disabled className="custom-select" id={"Pays" + index} tabIndex={-98} value={!R.isNil(selectedBranch) ? selectedBranch.address["addressCountry"] : ''} >
                                            {
                                                Object.keys(contriesList.getData()).map((country, idx) => {
                                                    return (
                                                        <option key={idx} value={country}>{countries.getName(country, "fr", { select: "official" })}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="mb-gutter" />
                {
                    !R.isNil(branchIsSelected) && !R.isNil(selectedBranch) ?
                        connectionType === ConnectionTypes.bank ?
                            <BankDetails formRef={formRef} index={index} isMain={isMain} branch={selectedBranch} removeBranch={removeBranch} setCollapsed={setCollapsed} serviceData={branch} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} /> :
                            <BranchBox formRef={formRef} index={index} connectionType={connectionType} branch={selectedBranch} removeBranch={removeBranch} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} />
                        : ''
                }
            </form>
        </section>
    );
};